const searchRegex = /\{(\w+)}/g;

export function StringFormatter(text: string, attrs: string[]): string;
export function StringFormatter(text: string, attrs: Record<string, string>): string;
export function StringFormatter(text: string, attrs: string[] | Record<string, string>): string;
export function StringFormatter(text: string, attrs: string[] | Record<string, string>): string {
  return text.replace(searchRegex, (match: string, group: string) => (attrs as never)[group] || match);
}
